import { ReactiveComponent } from "../../core/ReactiveComponent.core";
import { ICON } from "../Icons/Icons";
import { SCENE_EVENTS } from "../MVC/EVENTS/ModelEvents";
import DeviceSettings from "./DeviceSettings";
import { NotificationSettings } from "./NotificationSettings";
import DeviceSettingsAlone from "./DeviceSettingsAlone";

export const SETTING_MENU = {
    DEVICE_SETTINGS: 'DEVICE_SETTINGS',
    NOTIFICATION_SETTINGS: 'NOTIFICATION_SETTINGS',
}

const settingMenuTemplate = `
<div class="custom-modal">
    <div class="custom-modal__dialog custom-modal__dialog--size-large custom-modal__dialog--theme-dark">
        <div class="custom-modal__dialog__content">
            <div class="settings-modal">
                <div class="settings-modal__sidebar">
                    <h2 class="settings-modal__sidebar__header">Settings</h2>
                    <ul class="settings-modal__sidebar__menu">
                        <li
                            id="trigger-device-settings"
                            class="settings-modal__sidebar__menu-item"    
                        >
                            ${ICON.CONFIG}
                            <span>Device Settings</span>
                        </li>
                        <li
                            id="trigger-notification-settings"
                            class="settings-modal__sidebar__menu-item"
                        >
                             ${ICON.BELL}
                            <span>Notifications</span>
                        </li>
                    </ul>
                </div>
                <div class="settings-modal__content">
                    <!-- Children here -->
                </div>
            </div>
        </div>
    </div>
</div>
`
export class SettingMenu extends ReactiveComponent {
    constructor({ model, socket }) {
        const template = $(settingMenuTemplate)
        $(document.body).append(template)

        super(template, {
            isShow: false,
            activeMenu: 'device-settings',
        })

        this.model = model
        this.socket = socket

        this.template = template
        this.$element = {
            content: this.template.find('.settings-modal__content'),
        }

        this.deviceSettingMenu = new DeviceSettingsAlone({ model, socket })
        $('body').append(this.deviceSettingMenu.template)

        /*this.deviceSettingMenu = new DeviceSettings({ model, socket })
        this.$element.content.append(this.deviceSettingMenu.template)

        this.notificationSettingMenu = new NotificationSettings({ model, socket })
        this.$element.content.append(this.notificationSettingMenu.template)*/

        this.template.find('#trigger-notification-settings').hide();//temporary

        this.bindStates()
        this.addEventListeners()
    }

    bindStates() {
        this.bindState('isShow', (isShow) => {
            if (isShow) {
                this.template.addClass('custom-modal--visible')
            } else {
                this.template.removeClass('custom-modal--visible')
                this.deviceSettingMenu.onClose()
            }
        })

        this.bindState('activeMenu', (activeMenu) => {
            if (activeMenu === SETTING_MENU.DEVICE_SETTINGS) {
                this.template.find('.settings-modal__content__section').hide()
                this.template.find('.settings-modal__sidebar__menu-item').removeClass('settings-modal__sidebar__menu-item--active')
                this.template.find('#device-settings').show()
                this.template.find('#trigger-device-settings').addClass('settings-modal__sidebar__menu-item--active')

                this.model.dispatchEvent({ type: SCENE_EVENTS.OPEN_MEDIA_SETTINGS })
            } else if (activeMenu === SETTING_MENU.NOTIFICATION_SETTINGS) {
                this.template.find('.settings-modal__content__section').hide()
                this.template.find('.settings-modal__sidebar__menu-item').removeClass('settings-modal__sidebar__menu-item--active')
                this.template.find('#notification-settings').show()
                this.template.find('#trigger-notification-settings').addClass('settings-modal__sidebar__menu-item--active')
            }
        })
    }

    addEventListeners() {
        // Show/hide this menu modal
        this.model.addEventListener(SCENE_EVENTS.OPEN_SETTING_MENU, (e) => {
            // this.state.isShow = true
            // this.state.activeMenu = e.payload?.selectedMenu ?? SETTING_MENU.DEVICE_SETTINGS

            this.model.dispatchEvent({ type: SCENE_EVENTS.OPEN_MEDIA_SETTINGS })
        })
        this.template.find('.settings-modal__content__section__close-btn').on('click', () => {
            this.state.isShow = false
        })
        this.template.on('click', (e) => {
            var $target = $(e.target)
            var $element = this.template.find('.custom-modal__dialog')
            if (!$element.is($target) && $element.has($target).length === 0) {
                // User has clicked outside the dialog
                this.state.isShow = false
            }
        })

        // Change setting menu
        this.template.find('#trigger-notification-settings').on('click', () => {
            this.state.activeMenu = SETTING_MENU.NOTIFICATION_SETTINGS
        })
        this.template.find('#trigger-device-settings').on('click', () => {
            this.state.activeMenu = SETTING_MENU.DEVICE_SETTINGS
        })
    }

    toggle(isToggle = null) {
        if (isToggle === null) {
            isToggle = !this.state.isShow
        }
        this.state.isShow = isToggle
    }
}
